export default __webpack_public_path__ + "static/media/favoritos.b201aac8.svg";